/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import MonthlyTransactionStore from '../../store/transaction/MonthlyTransactionStore'
import ListView from '../../view/pages/transaction/ListView'

class MonthlyListContainer extends Component {
  static getStores() {
    return [MonthlyTransactionStore]
  }

  static calculateState(prevState, props) {
    return {
      transactions: MonthlyTransactionStore.getState(),
      ...props
    }
  }

  componentDidMount() {}

  render() {
    return ListView(this.state)
  }
}

export default withRouter(Container.create(MonthlyListContainer, { withProps: true }))
